import { useState } from 'react';
import { api } from '../../api';

/*
 * Отсчёт времени в звонке (спека второй порции, раздел 3.3). Заводит ведущий:
 * число минут и запуск. У разговора встречи окна нет вовсе — там отсчёт идёт
 * по календарю и руками не меняется, поэтому пункт меню туда не попадает.
 *
 * Окно собрано на существующих классах дизайн-системы (.backdrop/.dialog,
 * 3.13) — своих для окна не заводим.
 */
export function TimerDialog({
  callId,
  on,
  onClose,
}: {
  callId: string;
  /** Отсчёт уже идёт: показываем «Снять». */
  on: boolean;
  onClose: () => void;
}) {
  const [minutes, setMinutes] = useState(15);
  const [busy, setBusy] = useState(false);

  const send = (value: number | null) => {
    setBusy(true);
    api
      .callTimer(callId, value)
      .then(onClose)
      .catch(() => setBusy(false));
  };

  return (
    <div className="backdrop" onClick={onClose}>
      <div className="dialog" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-body">
          <h2>Отсчёт времени</h2>
          <p>Отсчёт видят все участники. По нулю звонок не кончается: счёт пойдёт вверх.</p>
          <div className="field">
            <label htmlFor="call-timer-min">Минут</label>
            <input
              id="call-timer-min"
              className="input"
              type="number"
              min={1}
              max={1440}
              value={minutes}
              onChange={(e) => setMinutes(Number(e.target.value))}
            />
          </div>
        </div>
        <div className="dialog-foot">
          {on && (
            <button className="btn outline" disabled={busy} onClick={() => send(null)}>
              Снять
            </button>
          )}
          <button className="btn outline" disabled={busy} onClick={onClose}>
            Отмена
          </button>
          <button
            className="btn"
            disabled={busy || !Number.isInteger(minutes) || minutes < 1 || minutes > 1440}
            onClick={() => send(minutes)}
          >
            Запустить
          </button>
        </div>
      </div>
    </div>
  );
}
